import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CourseSectionService } from '../../services/course-section.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-registered-course',
  templateUrl: './registered-course.component.html',
  styleUrls: ['./registered-course.component.scss']
})
export class RegisteredCourseComponent implements OnInit, OnDestroy {


  registeredCourses: any[] = [];
  loading = false;
  limit = 10;
  offset = 0;
  endOfData = false;
  allDataLoaded = false;
  initialLoadDone = false;
  openFilter = false;
  searchControl = new FormControl('');
  private destroy$ = new Subject<void>();
  private currentSearchTerm = '';
  getCourseType: any[] = [];
  filteredCourseTypes: any[] = [];
  filterType = '';
  private lastTypeSearch = '';
  private typeInput$ = new Subject<string>();
  private categoryInput$ = new Subject<string>();


  getCourseCategories: any[] = [];
  filteredCourseCategories: any[] = [];
  filterCategory: string = '';
  lastCategorySearch: string = '';

  constructor(
    private courseSectionService: CourseSectionService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.fetchRegisteredCourses();

    //  Debounced search
    this.searchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((value: string) => {
        const term = value?.trim();
        if (term === this.currentSearchTerm) return;
        this.currentSearchTerm = term || '';
        // reset pagination on new search
        this.offset = 0;
        this.registeredCourses = [];
        this.allDataLoaded = false;
        this.fetchRegisteredCourses();
      });

    // Debounced TYPE input: only filter list, do NOT fetch API
    this.typeInput$
      .pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((value: string) => {
        const trimmedValue = (value || '').trim();
        if (!trimmedValue) {
          this.filteredCourseTypes = [...this.getCourseType];
          return;
        }
        this.filteredCourseTypes = this.getCourseType.filter(ct =>
          (ct.name || '').toLowerCase().includes(trimmedValue.toLowerCase())
        );
      });
    // Debounced CATEGORY input: only filter list, do NOT fetch API
    this.categoryInput$
      .pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((value: string) => {
        const trimmedValue = (value || '').trim();
        if (!trimmedValue) {
          this.filteredCourseCategories = [...this.getCourseCategories];
          return;
        }
        this.filteredCourseCategories = this.getCourseCategories.filter(cat =>
          (cat.name || '').toLowerCase().includes(trimmedValue.toLowerCase())
        );
      });
  }

  // Modify your input handlers to emit values instead of direct logic
  onTypeInput(value: string): void {
    this.typeInput$.next(value);
  }

  onCategoryInput(value: string): void {
    this.categoryInput$.next(value);
  }


  fetchRegisteredCourses() {
    if (this.loading || this.allDataLoaded) return;

    this.loading = true;

    this.courseSectionService.getRegisteredCourses(
      this.limit,
      this.offset,
      this.currentSearchTerm,
      this.filterType,
      this.filterCategory,
      this.filterMonth
    ).subscribe({
      next: (result: any) => {
        const newCourses = result?.data?.courses || [];

        if (newCourses.length > 0) {
          this.registeredCourses = [...this.registeredCourses, ...newCourses];

          this.offset += this.limit;

          // **Check if returned count < limit, meaning we've reached the end**
          if (newCourses.length < this.limit) {
            this.allDataLoaded = true;
          }
        } else {
          this.allDataLoaded = true;
        }

        this.loading = false;
        this.initialLoadDone = true;
        this.spinner.hide();
      },
      error: (err) => {
        console.error('Error fetching registered courses', err);
        this.loading = false;
        this.initialLoadDone = true;
        this.spinner.hide();
      }
    });
  }

  onScroll() {
    if (this.loading || this.allDataLoaded) return;
    this.fetchRegisteredCourses();
  }

  trackByRegId(index: number, item: any): string {
    return item.id;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // filter 

  toggleFilter(): void {
    this.openFilter = !this.openFilter;


    if (this.openFilter) {
      if (!this.getCourseType.length) {
        this.getCourseTypes();
      }
      if (!this.getCourseCategories.length) {
        this.getCourseCatagories();
      }
    }


  }

  // TYPE FILTER
  getCourseTypes(): void {
    this.courseSectionService.getCourseType().subscribe((res: any) => {

      this.getCourseType = res || [];
      this.filteredCourseTypes = [...this.getCourseType];

    });
  }


  onTypeSelected(selectedName: string): void {
    this.filterType = selectedName;
    this.filteredCourseTypes = [...this.getCourseType];
    this.lastTypeSearch = selectedName.trim();
    this.refreshCurrentTabData();
  }
  onTypeScrolled(index: number): void {
    if (index + 5 >= this.filteredCourseTypes.length) {
      this.getCourseTypes();
    }
  }

  refreshCurrentTabData(): void {
    this.offset = 0;
    this.endOfData = false;
    this.registeredCourses = [];
    this.allDataLoaded = false;
    this.fetchRegisteredCourses();
  }

  // --- CATEGORY FILTER ---



  getCourseCatagories(): void {
    this.courseSectionService.getCourseCategories().subscribe((res: any) => {
      this.getCourseCategories = res || [];
      this.filteredCourseCategories = [...this.getCourseCategories];
    });
  }



  onCategorySelected(selectedName: string): void {
    this.filterCategory = selectedName;
    this.filteredCourseCategories = [...this.getCourseCategories];
    this.lastCategorySearch = selectedName.trim();
    this.refreshCurrentTabData();
  }

  onCategoryScrolled(index: number): void {
    if (index + 5 >= this.filteredCourseCategories.length) {
      this.getCourseCatagories(); // Load more if required
    }
  }


  filterMonth: string = "";
  selectedMonth: Date | null = null;

  chosenDateHandler(date: Date | null): void {
    if (!date) {
      this.selectedMonth = null;
      this.filterMonth = "";
      this.offset = 0;
      this.endOfData = false;
      this.allDataLoaded = false; // reset
      this.registeredCourses = [];
      this.fetchRegisteredCourses();
      return;
    }

    this.selectedMonth = date;

    // Convert to 'yyyy-MM-dd' format
    const formatted = this.datePipe.transform(date, 'yyyy-MM-dd');
    this.filterMonth = formatted ?? '';

    this.offset = 0;
    this.endOfData = false;
    this.allDataLoaded = false;
    this.registeredCourses = [];
    this.fetchRegisteredCourses();
  }



  clearAllFilters(): void {
    const hadFilters =
      (this.filterType && this.filterType.trim() !== '') ||
      (this.filterCategory && this.filterCategory.trim() !== '') ||
      (this.filterMonth && this.filterMonth.trim() !== '');

    this.filterType = '';
    this.filterCategory = '';
    this.filterMonth = '';
    this.selectedMonth = null;

    this.filteredCourseTypes = [...this.getCourseType];
    this.lastTypeSearch = '';
    this.filteredCourseCategories = [...this.getCourseCategories];
    this.lastCategorySearch = '';

    if (hadFilters) {
      this.refreshCurrentTabData();
    }
  }

}
